/* eslint-disable import/no-unresolved */
import React, { memo, useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import DeliveryIcon from 'images/orders/delivery.svg';
import StoreIcon from 'images/orders/new-store.svg';

import CustomerAddressDropdown from '../../../../Customer/CustomerAddressDropdown';
import DeliveryMethodSelector from './DeliveryMethodSelector';
import ShippingCostFields from './ShippingCostFields';
import { useOrderDeliveryMethod } from '../../../hooks/useOrderDeliveryMethod';

const DeliveryMethod = ({ customer }) => {
  const { t: tCommon } = useTranslation('Common');
  const { t } = useTranslation('Orders');

  const {
    getValues, setValue, reset, control, trigger,
    formState: { errors }
  } = useFormContext();

  const {
    shop_active_send_order,
    shop_active_store_pickup,
    shipping_cost_method,
    deliveryMethod,
    shipping_cost_id,
    shippingCostOptions,
    canShowDelivery,
    loadingShippingCosts
  } = useOrderDeliveryMethod({
    useWatch, reset, getValues, setValue, control, trigger
  });

  const handleSelectSendOrder = useCallback(() => setValue('delivery_method', 'send_order'), [setValue]);
  const handleSelectStorePickup = useCallback(() => setValue('delivery_method', 'store_pickup'), [setValue]);

  if (!canShowDelivery) return null;

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div className="tw-flex tw-flex-col tw-gap-2">
        <h1 className="tw-mb-0 tw-font-semibold tw-text-gray-950 tw-text-sm">{t('deliveryMethod.title')}</h1>

        <div className="tw-flex tw-flex-col tw-gap-4">
          {shop_active_send_order && (
            <DeliveryMethodSelector
              icon={DeliveryIcon}
              label={t('deliveryMethod.sendOrder')}
              selected={deliveryMethod === 'send_order'}
              onSelect={handleSelectSendOrder}
            />
          )}

          {shop_active_store_pickup && (
            <DeliveryMethodSelector
              icon={StoreIcon}
              label={t('deliveryMethod.storePickup')}
              selected={deliveryMethod === 'store_pickup'}
              onSelect={handleSelectStorePickup}
            />
          )}
        </div>

        {errors.delivery_method?.message && (
          <div className="tw-flex tw-px-1">
            <span className="tw-text-xs tw-text-red-500">
              {errors.delivery_method?.message}
            </span>
          </div>
        )}
      </div>

      {deliveryMethod === 'send_order' && shop_active_send_order && (
        <div className="tw-flex tw-flex-col tw-gap-4">
          <div className="tw-flex tw-gap-2">
            <div className="tw-flex-1 tw-min-w-0">
              <CustomerAddressDropdown customer={customer} />
            </div>

            <div className="tw-flex-1 tw-min-w-0">
              <ShippingCostFields
                method={shipping_cost_method}
                options={shippingCostOptions}
                shipping_cost_id={shipping_cost_id}
                getValues={getValues}
                tCommon={tCommon}
                loadingShippingCosts={loadingShippingCosts}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(DeliveryMethod);
